import React from 'react';
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import ModalCustom from "../../../shared/ui/modal/ModalCustom";
import {FormElements} from "../../../shared/ui/form/FormElements";
import {UseFormSubmitModel} from "../../../shared/utils/forms/models/UseFormModel";
import {useForm} from "../../../shared/utils/forms/useForm";

const ModalLoadModel = ({confirmHandler, closeHandler, models}: any) => {

    const structureData: any[] = [
        {
            type: 'select',
            name: "model",
            label: "Modello",
            options: models.map((ele: any) => ({value: ele.idDocument, label: ele.name})),
            dataElement: {
                placeholder: "Seleziona modello",
                type: 'text',
            },
            col: {xs: "12"},
        },
    ]
    const validationData = {
        model: {
            required: {
                params: {
                    name: "Modello",
                },
            },
        },
    }

    const submitHandler: UseFormSubmitModel = (event, data) => {
        confirmHandler(data)
    };
    const {
        isSubmit,
        errors,
        submitAction,
        changeValue,
        dataForm,
        setData
    } = useForm(submitHandler, validationData);

    return (
        <ModalCustom title={"Carica Modello"} closeModal={closeHandler}
                     footerTemplate={<div className={'btn-row'}>
                         <BtnPrimary onClick={closeHandler}
                                     variant={'outline-primary'}
                                     className={'text-primary'}>Annulla</BtnPrimary>
                         <BtnPrimary onClick={submitAction}>Conferma</BtnPrimary>
                     </div>}>
            <p>Seleziona il modello da caricare.</p>
            <FormElements
                structure={structureData}
                dataForm={dataForm}
                errors={errors}
                isSubmit={isSubmit}
                changeValue={changeValue}
            />
        </ModalCustom>
    );
};

export default ModalLoadModel;
